import type {
  GrowthAutopilotAction,
  GrowthBrainInsight,
  GrowthMetricDef,
  GrowthQuickNavItem,
  GrowthValueCardDef,
} from './types';

export const GROWTH_APPROVAL_BREAKDOWN = [
  ['2', 'ad campaigns'],
  ['3', 'articles'],
  ['1', 'landing page'],
  ['1', 'review response'],
] as const;

export const GROWTH_BUSINESS_METRICS: GrowthMetricDef[] = [
  { label: 'New patients', value: '47', delta: '+23%', deltaDir: 'up', deltaLabel: 'vs March' },
  {
    label: 'Marketing ROI',
    value: '4.8x',
    accent: 'success',
    delta: '+0.6x',
    deltaDir: 'up',
    deltaLabel: 'vs March',
  },
  {
    label: 'Cost per patient',
    prefix: '$',
    value: '138',
    delta: '-$24',
    deltaDir: 'down',
    deltaLabel: 'vs March',
  },
  {
    label: 'Ad spend',
    prefix: '$',
    value: '4,280',
    sub: 'of $6,000 · on pace',
    bar: 71,
  },
  {
    label: 'Organic traffic',
    value: '3,412',
    delta: '+18%',
    deltaDir: 'up',
    deltaLabel: '30-day trend',
  },
];

export const GROWTH_BRAIN_INSIGHTS: GrowthBrainInsight[] = [
  {
    heading: 'When Dr. Chen had open blocks',
    body: 'Increased ad spend 23% on Tues/Thurs · Filled 9 slots worth $11,200',
  },
  {
    heading: 'When schedule was full',
    body: 'Paused $340 of ad spend · Saved waste when no capacity existed',
  },
  {
    heading: 'Offline conversions',
    body: 'Sent 28 real patient conversions to Google · Improved targeting 40%',
  },
  {
    heading: 'Real appointment value',
    body: 'Told Google implants = $4,200 avg · Bids optimized for revenue',
  },
];

export const GROWTH_VALUE_CARDS: GrowthValueCardDef[] = [
  {
    label: 'Money saved',
    prefix: '$',
    value: '1,720',
    accent: 'success',
    icon: 'dollar',
    lines: [
      { t: 'Paused 8 underperformers:', v: '$1,240' },
      { t: 'Blocked 47 junk keywords:', v: '$340' },
      { t: 'Cheaper bid timing:', v: '$140' },
    ],
  },
  {
    label: 'Errors caught',
    value: '14',
    accent: 'gold',
    icon: 'alert',
    lines: [
      { t: '3 tracking pixel issues fixed' },
      { t: '2 compliance violations auto-corrected' },
      { t: '9 low-quality search terms blocked' },
    ],
  },
  {
    label: 'Opportunities captured',
    value: '6',
    accent: 'info',
    icon: 'bolt',
    lines: [
      { t: 'Bid up when competitor paused:', v: '+$2,100' },
      { t: 'Spanish keyword cluster:', v: '12 leads' },
      { t: 'Weekend emergency capture:', v: '5 bookings' },
    ],
  },
  {
    label: 'Work completed',
    value: '101',
    suffix: 'tasks',
    accent: 'lav',
    icon: 'check',
    lines: [
      { t: '8 SEO articles written' },
      { t: '32 Google Business posts' },
      { t: '47 review responses drafted' },
      { t: '14 ad variations created' },
    ],
  },
  {
    label: 'Time saved',
    value: '28',
    suffix: 'hours',
    accent: 'ai',
    icon: 'clock',
    lines: [
      { t: 'Content research & writing:', v: '14 hrs' },
      { t: 'Campaign monitoring:', v: '9 hrs' },
      { t: 'Reviews & GBP posts:', v: '5 hrs' },
    ],
  },
];

export const GROWTH_AUTOPILOT_ACTIONS: GrowthAutopilotAction[] = [
  {
    time: '12 min ago',
    icon: 'swap',
    cat: 'Budget',
    tone: 'ai',
    action: 'Shifted $80/day from Hygiene → Emergency (12 open blocks this week)',
  },
  {
    time: '2h ago',
    icon: 'minus',
    cat: 'Paused',
    tone: 'gold',
    action: "Paused 'Family Dentistry Broad Match' — spent $340 with zero conversions in 14 days",
  },
  {
    time: '4h ago',
    icon: 'target',
    cat: 'Keyword',
    tone: 'info',
    action: "Added 12 negative keywords: 'free dentist', '24 hour dental', 'volunteer dentistry'",
  },
  {
    time: '6h ago',
    icon: 'store',
    cat: 'Published',
    tone: 'success',
    action: "GBP post published: 'April whitening special — limited slots available'",
  },
  {
    time: '8h ago',
    icon: 'search',
    cat: 'SEO',
    tone: 'lav',
    action: 'Auto-fixed schema markup on /implants page — added FAQPage and Dentist schema',
  },
];

export const GROWTH_QUICK_NAV: GrowthQuickNavItem[] = [
  { title: 'Competitors', sub: 'Market intelligence & SWOT', icon: 'globe', tone: 'terra' },
  { title: 'Campaigns', sub: 'Google Ads performance', icon: 'target', tone: 'ai' },
  { title: 'SEO & Content', sub: 'Keywords, articles, audits', icon: 'doc', tone: 'info' },
  { title: 'GBP Manager', sub: 'Reviews, posts, photos', icon: 'store', tone: 'gold' },
];
